/** /old-versions/ 页面数据（与飞书 PRD 对齐） */

/** 与飞书文档表格 Vu3oJV 一致 */
export const VERSION_HISTORY_ROWS = [
  { version: '18.80', size: '78 MB', published: 'April 2026', android: 'Android 5.0+' },
  { version: '18.70', size: '77 MB', published: 'February 2026', android: 'Android 5.0+' },
  { version: '18.60', size: '65 MB', published: 'January 2026', android: 'Android 5.0+' },
  { version: '18.50', size: '76 MB', published: 'December 2025', android: 'Android 5.0+' },
  { version: '18.00', size: '76 MB', published: 'November 2025', android: 'Android 5.0+' },
  { version: '17.90', size: '79 MB', published: 'October 2025', android: 'Android 5.0+' },
  { version: '17.80', size: '75 MB', published: 'September 2025', android: 'Android 5.0+' },
  { version: '17.50', size: '70 MB', published: 'August 2025', android: 'Android 5.0+' },
  { version: '17.00', size: '69 MB', published: 'July 2025', android: 'Android 5.0+' },
  { version: '16.80', size: '65 MB', published: 'June 2025', android: 'Android 5.0+' },
  { version: '16.50', size: '73 MB', published: 'May 2025', android: 'Android 5.0+' },
  { version: '16.00', size: '73 MB', published: 'April 2025', android: 'Android 5.0+' },
  { version: '15.00', size: '58 MB', published: 'December 2024', android: 'Android 4.0+' },
]

/** 与飞书文档表格 wJ7Sc9 一致 */
export const COMPARE_ROWS = [
  { feature: 'Interface', older: 'May use an earlier interface design', latest: 'May include interface changes' },
  { feature: 'Features', older: 'Includes the features available in that release', latest: 'May include newer features and changes' },
  { feature: 'Android Compatibility', older: "Depends on the release's documented requirements", latest: 'Check the requirements for the current release' },
  { feature: 'Updates', older: 'Older releases may no longer receive updates', latest: 'May include more recent changes' },
  { feature: 'Bug Fixes', older: 'May lack fixes introduced in later releases', latest: 'May include documented fixes' },
  { feature: 'Login Compatibility', older: 'May encounter compatibility or service access issues', latest: 'Current compatibility is not guaranteed' },
  { feature: 'Security Considerations', older: 'May lack later fixes and carry additional risks', latest: 'Still requires source verification because GB WhatsApp is unofficial' },
  { feature: 'Installation', older: 'Downgrading may introduce installation or data conflicts', latest: 'Depends on device compatibility and the existing installation' },
]

export const PREVIOUS_RELEASES = [
  { version: '18.70', description: 'An earlier release for users comparing previous versions with the current GB WhatsApp release.' },
  { version: '18.60', description: 'Review this previous release when researching historical versions and checking the requirements for an older APK.' },
  { version: '18.50', description: 'An earlier version included for users comparing release history and available installation information.' },
  { version: '18.30', description: 'Review the available information for this historical release before considering installation.' },
  { version: '17.90', description: 'An older release for users researching previous GB WhatsApp versions and their documented requirements.' },
  { version: '17.80', description: 'Compare this release with later versions and review the available historical information.' },
  { version: '17.50', description: 'A previous release included for users exploring the GB WhatsApp version history.' },
  { version: '17.00', description: 'Review this earlier release when comparing historical versions and installation requirements.' },
  { version: '16.80', description: 'An older version listed for users researching previous releases.' },
  { version: '16.50', description: 'Check the available version information before considering this historical release.' },
  { version: '16.00', description: 'Review this previous release as part of the historical GB WhatsApp version list.' },
]

export const TOP_OLD_VERSIONS = [
  { version: '15.00', year: '2024', android: 'Android 4.0+ according to the supplied reference.' },
  { version: '13.60', year: '2023', android: 'Android 3.0+ according to the supplied reference.' },
  { version: '11.50', year: '2021', android: 'Android 4.0+ according to the supplied reference.' },
  { version: '9.98', year: '2019', android: 'Android 3.0+ according to the supplied reference.' },
]

export const INSTALL_STEPS = [
  {
    title: 'Step 1: Choose the Required Version',
    text: 'Review the GB WhatsApp version history and identify the exact release you want to use. Confirm that the corresponding APK is available before proceeding.',
  },
  {
    title: 'Step 2: Check Android Compatibility',
    text: 'Check the documented Android requirements for that specific release and compare them with your device\'s operating system. Do not assume that all older versions support the same Android devices.',
  },
  {
    title: 'Step 3: Back Up Important Data',
    text: 'Review the backup options available in your current installation. Confirm how your data is stored and whether it can be restored before changing or uninstalling the app. Restoration between different modified versions is not guaranteed.',
  },
  {
    title: 'Step 4: Verify the APK File',
    text: 'Use a source you can reasonably verify. Check the file information and be cautious of unexpected redirects, unrelated installers or requests for unnecessary permissions.',
  },
  {
    title: 'Step 5: Review Installation Requirements',
    text: 'Android may block installation because of compatibility problems, conflicts with an existing installation or other installation restrictions. Review the relevant error message before making changes. Do not uninstall the current app until you understand the possible data consequences and have reviewed your recovery options.',
  },
  {
    title: 'Step 6: Check the App After Installation',
    text: 'If installation completes, check whether the app opens correctly and whether the required functions work. If it displays a message asking you to use official WhatsApp, do not assume that installing another older version will resolve the restriction. For additional precautions, read the <a href="/security-guide/">GB WhatsApp Security Guide</a>.',
  },
]

export const BEFORE_INSTALL_WARNINGS = [
  {
    title: 'Security Risks',
    text: 'Older releases may contain unresolved security issues or lack later fixes. A familiar version number does not prove that an APK file is authentic or safe.',
  },
  {
    title: 'Android Compatibility',
    text: 'Different releases may have different system requirements. Check the documented requirements for the specific version before installing it.',
  },
  {
    title: 'Chat and App Data',
    text: 'Changing or downgrading versions may affect chat history, media files and locally stored application data. Back up important information and review recovery options before making changes.',
  },
  {
    title: 'APK Source Verification',
    text: 'Check the source of the installation file. Avoid suspicious redirects, unrelated installers and files requesting unnecessary permissions.',
  },
  {
    title: 'Account Restrictions',
    text: 'GB WhatsApp is an unofficial modified application. Using an older release cannot guarantee account safety or prevent restrictions imposed by WhatsApp.',
  },
]

export const OLD_VERSION_FAQS = [
  {
    question: 'Can I Still Use an Older GB WhatsApp Version?',
    answer:
      'It depends on the specific release, device compatibility and whether the app can still connect to the service. Older versions may experience installation problems, compatibility limitations or account access issues.',
  },
  {
    question: 'How Do I Check GB WhatsApp Version Compatibility?',
    answer:
      'Check the Android requirements for the exact release and compare them with your device\'s operating system. If reliable compatibility information is unavailable, do not assume the version will work on your phone.',
  },
  {
    question: 'What Should I Do Before Installing an Older Version?',
    answer:
      'Verify the APK source, review compatibility requirements and back up important data. Confirm your recovery options before replacing or uninstalling your existing installation.',
  },
]

export const RELATED_SECURITY_LINKS = [
  {
    title: 'Is GB WhatsApp Safe to Use?',
    description:
      'Understand the privacy, security and account-related considerations associated with using an unofficial WhatsApp modification.',
    path: '/is-gb-whatsapp-safe-to-use/',
  },
  {
    title: 'Why Can GB WhatsApp Accounts Get Banned?',
    description:
      'Learn about possible account restrictions involving unofficial clients and the risks users should understand before continuing to use a modified app.',
    path: '/why-is-gb-whatsapp-account-banned/',
  },
  {
    title: 'What to Do When GB WhatsApp Says Use Official WhatsApp',
    description:
      'Understand what this warning may indicate and which practical options to consider when access through an unofficial client is restricted.',
    path: '/gb-whatsapp-says-use-official-whatsapp/',
  },
]
